<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <div>
                            <h3 class="card-title mb-0">
                                <i class="fas fa-tags tw:mr-2" aria-hidden="true"></i>
                                Descuentos
                            </h3>
                            <p class="card-text tw:mt-2 tw:mb-0 tw:text-sm tw:text-gray-600">
                                Gestiona los vouchers y promociones aplicables a esta sesión.
                            </p>
                        </div>
                        <div>
                            <Button id="nuevo-cupon" class="m-1" @click="showModal('CreateVoucher')">Nuevo cupón</Button>
                            <CreateVoucher :session_id="session_id" :event_id="event_id" v-on:close="closeModal"/>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div :class="['table', { 'expanded': voucher_codes.length <= 3 }]">
                            <table :class="['table', { 'expanded': voucher_codes.length <= 3 }, 'table-hover']" >
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Código</th>
                                        <th>Descuento (%)</th>
                                        <th>Descuento (fijo)</th>
                                        <th>Usos</th>
                                        <th class="text-center">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(voucher, index) in voucher_codes">
                                        <tr :key="index">
                                            <td>{{ voucher.name }}</td>
                                            <td>{{ voucher.code }}</td>
                                            <td>{{ voucher.discount_percent }}</td>
                                            <td>{{ voucher.discount_fixed }}</td>
                                            <td>{{ voucher.units }}</td>
                                            <td class="text-center">
                                                <OpcionesDropdownTableComponent 
                                                    :lastIndex="voucher_codes.length > 3 && index >= voucher_codes.length - 3"
                                                    v-bind:options="[
                                                        { type: 'action', action:() => showModal('UpdateVoucher-' + voucher.id), label: 'Editar'},
                                                        { type: 'action', action:() => showModal('DeleteVoucher-' + voucher.id), label: 'Borrar'},
                                                    ]"
                                                />
                                            </td>
                                            <EditarModal :event_id="event_id" :session_id="session_id" :voucher="voucher" v-on:close="closeModal"/>
                                            <BorrarModal :event_id="event_id" :session_id="session_id" :voucher="voucher" v-on:close="closeModal"/>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import CreateVoucher from './../../modals/CreateVoucher';
    import EditarModal from './../../modals/UpdateVoucher';
    import BorrarModal from './../../modals/DeleteVoucher';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';

    export default {
        props: ['event_id', 'session_id'],
        data() {
            return {
                sesion: null,
                voucher_codes: [],
                loading: false,
            }
        },
        created() {
            this.getSesion();
            this.getVouchers();
        },
        methods: {
            getVouchers() {
                this.loading = true;

                const params = {
                    filters : {},
                    event_id: this.event_id,
                    session_id: this.session_id
                };
                
                this.$store.dispatch(this.config.getVuexAlias('back.events.voucher.index'), params).then(res => {
                    this.voucher_codes = res.data.data;
                }).finally(() => this.loading = false);
            },
            getSesion() {
                this.loading = true;

                const params = {
                    filters : {},
                    evento_id: this.event_id,
                    sesion_id: this.session_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                    this.sesion = res.data.data;
                    this.entradas = res.data.data.entradas;
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, editado) {
                if(editado) this.getVouchers();
                this.$modal.hide(modal);
            },
        },
        components: {
            CreateVoucher, EditarModal, BorrarModal, OpcionesDropdownTableComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>